/*
 * Copyright 2026 ByOmakase, LLC (https://byomakase.org)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Observable} from 'rxjs';
import {type TimedItemsTrack} from '../../media';

import type {TrackLoadOptions} from '../track-load-options';

export interface TimedItemsFetcher {
  fetchTimedItems(): Observable<void>;
}

export abstract class BaseTimedItemsFetcher<T extends TimedItemsTrack> implements TimedItemsFetcher {
  protected _track: T;
  protected _loadOptions?: TrackLoadOptions | undefined;

  protected constructor(track: T, loadOptions?: TrackLoadOptions | undefined) {
    this._track = track;
    this._loadOptions = loadOptions;
  }

  public abstract fetchTimedItems(): Observable<void>;
}
